import Vue from 'vue';
import VueSession from 'vue-session';
import VueHead from 'vue-head';

import VueCryptojs from 'vue-cryptojs';
import GeoIP2 from './plugins/GeoIP2';
import StringsHelpers from './helpers/Strings';
import HeadHelper from './helpers/Head';
import GoogleJobs from './helpers/GoogleJobs';
import Encrypts from './helpers/Encrypts';

Vue.use(VueSession, {
  persist: true
});

Vue.use(VueHead, { separator: '' });

Vue.use(GeoIP2);

Vue.use(StringsHelpers);

Vue.use(GoogleJobs);

Vue.use(VueCryptojs);
Vue.use(Encrypts);

Vue.prototype.API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
Vue.prototype.DELTA_ENDPOINT = process.env.VUE_APP_DELTA_ENDPOINT;
Vue.prototype.PLATFORM_TEST = process.env.VUE_APP_PLATFORM_TEST;
Vue.prototype.OPPORTUNITIES_ENDPOINT = process.env.VUE_APP_OPPORTUNITIES_ENDPOINT;
Vue.prototype.OPPORTUNITIES_GRAPHQL_ENDPOINT = process.env.VUE_APP_OPPORTUNITIES_GRAPHQL_ENDPOINT;

// Only console if DEV
process.env.NODE_ENV == 'development' && console.log(`API_ENDPOINT = ${Vue.prototype.API_ENDPOINT}`);
process.env.NODE_ENV == 'development' && console.log(`DELTA_ENDPOINT = ${Vue.prototype.DELTA_ENDPOINT}`);
process.env.NODE_ENV == 'development' && console.log(`OPPORTUNITIES_ENDPOINT = ${Vue.prototype.OPPORTUNITIES_ENDPOINT}`);
process.env.NODE_ENV == 'development' && console.log(`OPPORTUNITIES_GRAPHQL_ENDPOINT = ${Vue.prototype.OPPORTUNITIES_GRAPHQL_ENDPOINT}`);

Vue.mixin({
  methods: {
    canUseServiceWorker(){
      return 'serviceWorker' in navigator && "Notification" in window;
    },
    subscribeNotification(){
      if (this.canUseServiceWorker()) {
        navigator.serviceWorker.ready.then(async serviceWorker => {
          let permission = await this.requestPermission();
  
          // Se não tiver permissão não segue
          if(permission != 'granted') return;
  
          let subscription = await serviceWorker.pushManager.getSubscription();
  
          // Se já tiver permissão não precisa seguir
          if(subscription) return;
  
          if(!subscription){
            const publicKeyResponse = await fetch(Vue.prototype.API_ENDPOINT + '/push/public_key', {
              headers: {
                "Authorization": "Token token=" + process.env.VUE_APP_API_TOKEN
              },
            });
            const publicKeyData = await publicKeyResponse.json()
  
            subscription = await serviceWorker.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: publicKeyData.public_key
            }).then(async (sub) => {
              var uid = Vue.prototype.$encrypts.decrypt(
                this.$store.state.user.profile.id,
                process.env.VUE_APP_API_TOKEN
              )
              if(!uid) return;
  
              await fetch(Vue.prototype.API_ENDPOINT + '/push/register', {
                method: 'POST',
                headers: {
                  "Authorization": "Token token=" + process.env.VUE_APP_API_TOKEN,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  subscription: sub,
                  user_id: uid,
                })
              });
            })
          }
        });
      }
    },

    requestPermission(){
      return new Promise((resolve, reject) => {
        Notification.requestPermission().then((permission) => {
          resolve(permission);
        });
      });
    },

    showField(group, fieldName) {
      const field = this.$store.state.user.formStruct[group].fields.find((field) => field.name == fieldName);
      return field && field.condition != 'off'
    },

    fieldIsRequired(group, fieldName) {
      const field = this.$store.state.user.formStruct[group].fields.find((field) => field.name == fieldName);
      return field && field.condition == 'required'
    },

    async subscribeUser(opportunity) {
      const opportunityId = (opportunity && opportunity.id) ? opportunity.id : this.$route.params.id.match(/\d+/)[0];
      const opportunity_questions = JSON.parse(localStorage.getItem('opportunity_questions'));

      if (!opportunity_questions || opportunity_questions.error == true) {
        this.$router.push(`/vagas/${this.$route.params.id}/inscricao`);
        return;
      }

      let source = localStorage.getItem('source');
      const sourceOpportunityId = localStorage.getItem('sourceOpportunityId');
      const indicationForm = localStorage.getItem('indication_form');


      if (source && parseInt(opportunityId) != parseInt(sourceOpportunityId)) {
        source = this.$store.state.source;
      }

      const subscriptionCallbackUrl = localStorage.getItem('subscriptionCallbackUrl')

      const { currentOpportunity } = this.$store.state.opportunities;
      let companyId = null;
      if (currentOpportunity.company_name) {
        companyId = currentOpportunity.company_name.indexOf('labs') !== -1 ? 2627 : null;
      }

      const subscriptionRequest = await this.$store.dispatch('opportunities/subscriptionNew', {
        opportunity_id: opportunityId,
        questions: opportunity_questions.data.questions,
        source: source,
        indication_form: indicationForm ? JSON.parse(indicationForm).data : null,
        send_confirmed_email: true,
        companyId,
      });

      if (subscriptionRequest.error) {
        if (subscriptionRequest.error.message) {
          this.$swal('Uoops', subscriptionRequest.error.message, 'error');
        } else {
          this.$swal('Uoops', 'Ocorreu um erro ao processar sua candidatura... Tente novamente mais tarde.', 'error');
        }

        this.$router.push(`/vagas/${this.$route.params.id}/inscricao`);
      } else {
        this.$store.commit('user/SET_FOLLOWER', true);

        if (source) {
          localStorage.removeItem('source');
          localStorage.removeItem('sourceOpportunityId');
        }

        if (indicationForm) {
          localStorage.removeItem('indication_form');
        }

        if (subscriptionCallbackUrl) {
          window.location.href = subscriptionCallbackUrl;
          localStorage.removeItem('subscriptionCallbackUrl');
        } else {
          this.$router.push(`/inscricao-confirmada?vaga=${this.$store.state.opportunities.currentOpportunity.title}&id=${opportunityId}`);
        }
      }

      return subscriptionRequest;
    },
  },
});

export default Vue;
